import { CultureInfo } from '../culture-info.model';
import { CultureInfoLn } from './ln';

/**
 * @ignore
 */
export const CultureInfoLnCG: CultureInfo = {
  name: 'ln-CG',
  displayName: 'lingála (Kongo)',
  iso3LanguageCode: 'lin',
  iso2LanguageCode: 'ln',
  ietfLanguageTag: 'ln-CG',
  parent: CultureInfoLn
};
